module.exports = __webpack_public_path__ + "static/img/pr_bg_3.09f46403.png";